import { service } from "./service";

export function logErrorApi(payload) {
  return service.post(`v3/public/log-error`, payload);
}

export function getGeoLocationApi() {
  return service.get(`v3/public/geo-location`);
}

export function getExchangeRateApi(payload) {
  return service.get(`v3/public/get-exchange-rate`, { params: payload });
}

export function getDestinationSuggestionsApi(query) {
  return service.get(`v3/public/get-destination-suggestions?query=${query}`);
}
